import { User } from './user';

export class Employee extends User {
  constructor(
    hash: string,
    firstname: string,
    lastname: string,
    email: string,
    birthDate: number,
    public password: string,
    public active: boolean,
    public admin: boolean,
    public salary: number
  ) {
    super(hash, firstname, lastname, email, birthDate);
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/employee.ts